export default __webpack_public_path__ + "static/media/program_intro_5.9be43914.png";